export function trimData<T>(data: T): T {
  if (data === null || data === undefined) {
    return data;
  }

  if (typeof data === 'string') {
    return data.trim() as unknown as T;
  }

  if (Array.isArray(data)) {
    return data.map((item) => trimData(item)) as unknown as T;
  }

  if (typeof data === 'object') {
    const result = {} as T;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        result[key] = trimData(data[key]);
      }
    }
    return result;
  }

  return data;
}

export const blankToUndefined = <T>(value: T): T | undefined =>
  typeof value === 'string' && value.trim() === '' ? undefined : value;
